import React, { useState } from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { Button, Input, Select } from "antd";
import CustomSelect from "../../../../../components/Elements/Select/CustomSelect";
import { API_URLS } from "../../../../../api/apiUrls";
import { postApi } from "../../../../../api/api_instance";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";
import { toast } from "react-hot-toast";
import { AcceptDialog } from "../../../../../components/Elements/DialogBox/AcceptDialog";
import { CheckOutlined } from "@ant-design/icons";
import PopupCard from "../../../../Auth/PopupCard";
import { Modal } from "antd";
const AddNewPopUp = ({ onOpen, onClose }) => {
  const [title, setTitle] = useState("");
  const { TextArea } = Input;
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });
  const [showAcceptDialog, setShowAcceptDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    title: "",
    description: "",
  });

  const triggerPopup = (type, title, message, duration = 3000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), duration);
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const response = await postApi({
        apiUrl: API_URLS.CREATE_CUSTOMFORM,
        data: {
          title,
          description,
        },
      });

      if (response.success) {
        // Modal.success({
        //   icon: null,
        //   centered: true,
        //   closable: true,
        //   className: "custom-success-modal",
        //   okButtonProps: { style: { display: "none" } }, // 👈 Hide OK button
        //   content: (
        //     <div className="flex flex-col items-center text-center p-4">
        //       <div className="bg-slate-300 p-2 rounded-full">
        //         {" "}
        //         <CheckOutlined style={{ fontSize: "48px", color: "#06513D" }} />
        //       </div>

        //       <h2 className="text-xl font-semibold text-[#000000] mb-2">
        //         Dynamics Survey Forms add Successfully
        //       </h2>
        //     </div>
        //   ),
        // });

        // Auto close the modal after 2s and trigger onClose

        triggerPopup(
          "success",
          "Success",
          "  Dynamics Survey Forms add Successfully",
        );
        setTimeout(() => {
          Modal.destroyAll();
          onClose();
        }, 2000);
      } else {
        toast.error(response.message || "Failed to create form.");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setErrorMessage({});
    onClose();
  };
  return (
    <>
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="800px">
        <div>
          <h3 className="text-xl font-bold text-[#06513D]">Add New </h3>
        </div>
        <div className="rounded-xl border mt-8 px-12 pt-5">
          <div className="flex flex-col gap-6">
            <Input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Title"
              className="h-14 rounded-lg"
            />
            {errorMessage.title && (
              <div className="text-red-500 text-sm">{errorMessage.title}</div>
            )}

            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-gray-700">
                Description
              </label>
              <TextArea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter description..."
                className="rounded-lg"
                autoSize={{ minRows: 4, maxRows: 6 }}
              />
              {errorMessage.description && (
                <div className="text-red-500 text-sm">
                  {errorMessage.description}
                </div>
              )}
            </div>
          </div>

          <div className="flex justify-center gap-6 p-5">
            <CustomButton
              buttonType="button"
              variant="cancel"
              buttonText="Cancel"
              onClick={handleCancel}
              className="text-base font-normal h-[50px] w-[160px]"
            />

            <CustomButton
              buttonType="button"
              variant="ok"
              buttonText="Save"
              onClick={handleSave}
              className="text-base font-normal h-[50px] w-[160px]"
            />
          </div>
          {showPopup && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
              <PopupCard
                type={popupData.type}
                title={popupData.title}
                message={popupData.message}
              />
            </div>
          )}
        </div>
      </DialogBox>
      {showAcceptDialog && (
        <AcceptDialog
          open={showAcceptDialog}
          close={() => {
            setShowAcceptDialog(false);
            onClose();
          }}
          heading="Success!"
          subheading="Dynamics  Survey Forms add Successfully "
          success={true}
        />
      )}
    </>
  );
};

export default AddNewPopUp;
